import {useEffect, useState} from 'react';

import {useParams} from 'react-router-dom';

import {
    Grid,
    Group
} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useMessage} from '../hooks/useMessage';
import {useMessagesSelection} from '../hooks/useMessagesSelection';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {MessageHtml} from "../components/MessageHtml.tsx";
import {MessageStatus} from '../types';
import {AddContactDrawer} from '../../contacts/drawers/AddContactDrawer';
import {useContact} from '../../contacts/hooks/useContact';
import {parseEmailAddress} from '../utils/parseEmailAddress';
import {Contact} from '../../contacts/types';

export const EditPage = () => {


    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record,
        loading,
        updateRecord,
        deleteRecord,
    } = useMessage(id);

    const {handleClearSelection} = useMessagesSelection();
    const {createRecord: createContact} = useContact();
    const [addContactDrawerOpened, setAddContactDrawerOpened] = useState(false);

    const contactInitialValues = record?.fromText
        ? (() => {
            const parsed = parseEmailAddress(record.fromText);
            const nameParts = parsed.name.split(' ');
            return {
                email: parsed.email,
                firstName: nameParts[0] || '',
                lastName: nameParts.slice(1).join(' ') || '',
            };
        })()
        : undefined;

    const {
        mode,
        tools,
        drawer,
    } = useEditPageTools(record, deleteRecord, updateRecord);


    useEffect(() => {
        handleClearSelection();

        // Mark message as read when opening detail page
        if (record && record.status === MessageStatus.UNREAD) {
            updateRecord({
                             ...record,
                             status: MessageStatus.READ
                         });
        }
    }, [record?.id]);

    if (loading || !record) {
        return <PlatformLoader message='Loading message...Please wait'/>;
    }


    return (
        <>
            <FormPageLayout
                title={record.subject ? record.subject : record.id}
                pageNavigation={<EditPageNavigation component={record}/>}
                tools={[]}
            >


                {mode === 'view' ?

                    <Grid>
                        <Grid.Col span={{
                            base: 4,
                            sm: 12
                        }}>
                            <Profile
                                record={record}
                                onAddToContacts={() => setAddContactDrawerOpened(true)}
                            />
                        </Grid.Col>
                        <Grid.Col span={{
                            base: 8,
                            sm: 12
                        }}>
                            <Group mb="md">
                                {tools}
                            </Group>
                            <MessageHtml record={record}/>
                        </Grid.Col>

                    </Grid>

                    :
                    <RecordForm
                        record={record}
                        handleSubmit={updateRecord}
                    />}


            </FormPageLayout>
            {drawer}
            <AddContactDrawer
                opened={addContactDrawerOpened}
                onClose={() => setAddContactDrawerOpened(false)}
                initialValues={contactInitialValues}
                onSubmit={(values: Contact) => createContact(values)}
            />
        </>
    );
};
